<template>
	<div class="images">
		<ul>
			<li v-for="(item, index) in 10" :key="index" @click="showDefectImage(item)">
				<img :src="demoImage" alt="" />
			</li>
		</ul>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				demoImage: require('@/assets/images/demo_01.jpg'),
			}
		},
		methods: {
			showDefectImage(item) {
				this.$emit('showDefectImage', item)
			},
		},
	}
</script>

<style scoped>
	.images {
		padding-bottom: 10px;
	}
	.images li {
		display: block;
		float: left;
		margin: 3px 3px 20px 3px;
	}

	.images li img {
		width: 100px;
		height: 120px;
	}
</style>
